/**
 * Default message templates configuration
 * Used as fallback when server data is not available
 */

const defaultTemplates = {
  // Company information
  // TODO(Gaffer)：以下公司資料待大力膠提供正式值後填入（後台設定頁可改）
  companyName: '大力膠',
  companyEmail: '',
  companyAddress: '',
  // RENT-56：報價單 / 出貨單 header 顯示用的公司電話
  companyPhone: '',
  companyTaxId: '',
  contactPerson: '',
  // BIGLI-33：逐門市的單據抬頭（公司設定 → 門市資訊）。預設為空 = 全部回退公司層級 company*。
  storeProfiles: [],
  lineService: '',
  portfolioUrl: 'https://foreverwebs.com/portfolio/',
  
  // Company image data (base64)
  companyLogoBase64: '',
  companySignatureBase64: '',
  companyStampBase64: '',
  
  // Bank information
  // TODO(Gaffer)：收款帳戶待大力膠提供，刻意留空避免沿用他人帳號
  accountName: '',
  bankName: '',
  branchName: '',
  bankCode: '',
  branchCode: '',
  bankAccount: '',
  
  // Message templates
  quotationNextAction: '確認無誤後請簽名回傳給Line@客服小幫手，若回傳簽名不方便請口頭告知小幫手報價單內容正確，我們就會啟動專案',
  invoicePaymentInstruction: '請於付款期限前完成款項支付，付款完成後請聯繫Line客服以便我們確認款項。如有任何疑問，歡迎隨時聯絡我們。',
  
  // Status display names
  statusPending: '待付款',
  statusPartial: '部分付款',
  statusPaid: '已付款',
  statusOverdue: '已逾期',
  
  // Signature labels
  companySignatureLabel: '大力膠',
  customerSignatureLabel: '客戶簽名',
  
  // Section titles
  remarksSectionTitle: '備註/補充',
  nextActionSectionTitle: '下一步行動',
  paymentInfoSectionTitle: '付款資訊',
  paymentInstructionTitle: '付款說明',
  
  // Last updated
  updatedAt: new Date().toISOString()
};

export default defaultTemplates;
